"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var composeRestyleFunctions_1 = __importDefault(require("../composeRestyleFunctions"));
var typeHelpers_1 = require("../typeHelpers");
var useDimensions_1 = __importDefault(require("./useDimensions"));
var useTheme_1 = __importDefault(require("./useTheme"));
var filterRestyleProps = function (props, omitList) {
    var omittedProp = omitList.reduce(function (acc, prop) {
        acc[prop] = true;
        return acc;
    }, {});
    return typeHelpers_1.getKeys(props).reduce(function (acc, key) {
        if (!omittedProp[key]) {
            acc[key] = props[key];
        }
        return acc;
    }, {});
};
var useRestyle = function (restyleFunctions, props) {
    var theme = useTheme_1.default();
    var dimensions = useDimensions_1.default();
    var composedRestyleFunction = react_1.useMemo(function () { return composeRestyleFunctions_1.default(restyleFunctions); }, [restyleFunctions]);
    var style = composedRestyleFunction.buildStyle(props, { theme: theme, dimensions: dimensions });
    var cleanProps = filterRestyleProps(props, composedRestyleFunction.properties);
    cleanProps.style = [style, props.style].filter(Boolean);
    return cleanProps;
};
exports.default = useRestyle;
